module.exports = __webpack_public_path__ + "static/under-the-big-top-5ba737c0cf52c467f81ba7c8831c856b.jpg";